import React, { useContext, useState } from 'react';
import { Form, Button, Input, Header, Icon, Image } from 'semantic-ui-react';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { Context } from '../../defaults';
import { isLoginExist } from '../../actions';
import style from './index.module.css';
import { emailRegex } from '../../common';

const Registration = () => {
  const { dictionary, language } = useContext(Context);
  const [currentStep, setCurrentStep] = useState(0);
  const [state, setState] = useState({});
  const [validations, setValidations] = useState({
    Login: false,
    Email: false,
    Password: false,
    RePassword: false,
  });
  const {
    UserRegistration,
    UserDetails,
    RegistrationSuccess,
    LoginExist,
    RegistrationDone,
    Next,
    EndRegistration,
    NotSamePassword,
    UserName,
    Password,
    RePassword,
    NotValidEmail,
    RequiredField,
  } = dictionary;

  const onChange = (e, { name, value, type }) => {
    setState({ ...state, [name]: value });
    if (type === 'email') {
      if (!emailRegex.test(value)) {
        setValidations({
          ...validations,
          [name]: `${NotValidEmail ? NotValidEmail[language] : ''}`,
        });
      } else {
        setValidations({ ...validations, [name]: false });
      }
    } else {
      if (!value) {
        setValidations({
          ...validations,
          [name]: `${RequiredField ? RequiredField[language] : ''}`,
        });
      } else {
        setValidations({ ...validations, [name]: false });
      }
    }
  };

  const clickNext = () => {
    switch (currentStep) {
      case 0: {
        if (userRegistrationStep()) {
          setCurrentStep(currentStep + 1);
        }
        break;
      }
      case 1: {
        if (userDetailsRegistrationStep()) {
          setCurrentStep(currentStep + 1);
        }
        break;
      }
      default: {
      }
    }
  };

  const clickEndRegistration = () => {};
  const userDetailsRegistrationStep = () => {
    return true;
  };

  const userRegistrationStep = () => {
    console.log(
      !validations.Login && !validations.Password && !validations.RePassword && !validations.Email,
    );
    console.log(
      state.Login &&
        state.Password &&
        state.RePassword &&
        state.Email &&
        emailRegex.test(state.Email),
    );
    if (
      !validations.Login &&
      !validations.Password &&
      !validations.RePassword &&
      !validations.Email
    ) {
      if (
        state.Login &&
        state.Password &&
        state.RePassword &&
        state.Email &&
        emailRegex.test(state.Email)
      ) {
        return true;
      }
    }
    const requiredField = `${RequiredField ? RequiredField[language] : ''}`;
    setValidations({
      ...validations,
      Login: state.Login ? false : requiredField,
      Email: state.Login ? false : requiredField,
      Password: state.Login ? false : requiredField,
      RePassword: state.Login ? false : requiredField,
    });
    return false;
  };

  const checkPassword = ({ target }) => {
    const { name, value } = target;
    if (state.Password !== value) {
      setValidations({
        ...validations,
        [name]: `${NotSamePassword ? NotSamePassword[language] : ''}`,
      });
    }
  };
  const checkLogin = ({ target }) => {
    const { value } = target;
    isLoginExist(value)
      .then((res) => res.json())
      .then((res) => {
        if (res) {
          setValidations({ ...validations, Login: LoginExist ? LoginExist[language] : '' });
        } else {
          setValidations({ ...validations, Login: false });
        }
      });
  };

  return (
    <div>
      <Stepper activeStep={currentStep}>
        <Step>
          <StepLabel>{UserRegistration ? UserRegistration[language] : ''}</StepLabel>
        </Step>
        <Step>
          <StepLabel>{UserDetails ? UserDetails[language] : ''}</StepLabel>
        </Step>
        <Step>
          <StepLabel>{RegistrationDone ? RegistrationDone[language] : ''}</StepLabel>
        </Step>
      </Stepper>
      {currentStep === 0 && (
        <Form className={style.content}>
          <Form.Group widths="equal">
            <Form.Field
              fluid
              control={Input}
              onChange={onChange}
              onBlur={checkLogin}
              name="Login"
              label={`${UserName ? UserName[language] : ''}`}
              error={validations.Login}
            />
            <Form.Field
              fluid
              control={Input}
              onChange={onChange}
              type="email"
              name="Email"
              label="Email"
              placeholder="example@mail.com"
              error={validations.Email}
            />
          </Form.Group>
          <Form.Group widths={'equal'}>
            <Form.Field
              fluid
              onChange={onChange}
              control={Input}
              name="Password"
              type="password"
              label={`${Password ? Password[language] : ''}`}
              error={validations.Password}
            />
            <Form.Field
              fluid
              control={Input}
              onChange={onChange}
              onBlur={checkPassword}
              name="RePassword"
              type="password"
              label={`${RePassword ? RePassword[language] : ''}`}
              error={validations.RePassword}
            />
          </Form.Group>
        </Form>
      )}
      {currentStep === 1 && (
        <Form className={style.content}>
          <Form.Select />
        </Form>
      )}
      {currentStep === 2 && (
        <div className={style.content}>
          <Header as="h2" icon textAlign="center">
            <Icon name="users" circular />
            <Header.Content>
              {RegistrationSuccess ? RegistrationSuccess[language] : ''}
            </Header.Content>
          </Header>
          <Image
            centered
            size="large"
            src="https://react.semantic-ui.com/images/wireframe/centered-paragraph.png"
          />
        </div>
      )}

      <div className={style.content}>
        {currentStep < 2 && (
          <Button basic className={style.actions} onClick={clickNext}>
            {Next ? Next[language] : ''}
          </Button>
        )}
        {currentStep === 2 && (
          <Button basic className={style.actions} onClick={clickEndRegistration}>
            {EndRegistration ? EndRegistration[language] : ''}
          </Button>
        )}
      </div>
    </div>
  );
};

export default Registration;
